const deleteServices = {
  toastr: 'Servicio eliminado'
};

export default deleteServices;
